import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { useField } from 'formik';
import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Slider, { SliderProps } from './designsystem/Slider';
import { FormattedMessage } from 'react-intl';

const RatingFilter = () => (
    <>
        <FilterCaption>
            <p>Minimale beoordeling</p>
        </FilterCaption>
        <RatingFilterSlider />
    </>
);

export default RatingFilter;

type OnChange = SliderProps['onChange'];

const RatingFilterSlider = () => {
    const [{ value }, meta, { setValue, setTouched }] = useField<[number, number]>('rating');

    const [currentRating, setCurrentRating] = useState(value);
    const [isChanging, setIsChanging] = useState(false);

    useEffect(() => {
        if (!isChanging && !isEqual(value, currentRating)) {
            setCurrentRating(value);
        }
    }, [currentRating, isChanging, value]);

    const onAfterChange = (val: [number, number]) => {
        setIsChanging(false);
        setValue(val);
        if (!meta.touched) {
            setTouched(true);
        }
    };

    return (
        <>
            <StyledSliderField
                min={0}
                max={10}
                step={0.1}
                defaultValue={meta.initialValue ?? value}
                value={currentRating}
                onBeforeChange={() => setIsChanging(true)}
                onChange={setCurrentRating as OnChange} // why tho
                onAfterChange={onAfterChange as OnChange}
            />
            <SliderBody>
                <FormattedMessage
                    defaultMessage="{rating} sterren"
                    values={{
                        rating: currentRating ?? 0,
                    }}
                />
            </SliderBody>
        </>
    );
};

const FilterCaption = styled(Body).attrs({ variant: 'micro' })`
    font-weight: bold;
    margin-bottom: ${({ theme }) => theme.spacing['40_Standard']};
`;

const StyledSliderField = styled(Slider)`
    @media screen and (max-width: ${({ theme }) => theme.mediaQueriesValues.s}px) {
        width: 100%;
    }
`;

const SliderBody = styled(Body)`
    font-weight: 600;
    font-size: 1.5rem;
    text-align: center;
    margin: ${({ theme }) => theme.spacing['40_Standard']} 0;
`;
